import { render, staticRenderFns } from "./EditShopSettings.vue?vue&type=template&id=7cec4b3e&"
import script from "./EditShopSettings.vue?vue&type=script&lang=js&"
export * from "./EditShopSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports